import React from "react";
import { Button, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButton = ({ label = "Back", to, onClick, sx = {} }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={handleClick}
      sx={{
        color: theme.customColors?.text?.secondary,
        textTransform: "none",
        fontWeight: 500,
        "&:hover": { bgcolor: theme.customColors?.background?.light },
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};

export default BackButton;
